import Icon from '../components/Icon.vue'

Icon.register({
  italic: {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M320 48v32c0 8.8-7.2 16-16 16h-62.8l-80 320h46.8c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-192c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h62.8l80-320h-46.8c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16z'
      }
    ]
  }
})
